module.exports = __webpack_public_path__ + "static/img/4.590d46d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Multiriesgo-corporativo/4.png
// module id = mNQR
// module chunks = 0